export default async function(to, from, next) {
	const school = this.state.currentUser?.school;

	if (school?.features_essay_review) {
		return next();
	} else {
		return next("/dashboard");
	}
}
